module.exports = __webpack_public_path__ + "static/img/MICHAEL_BEVAN.6777a3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MICHAEL_BEVAN.jpg
// module id = hfMN
// module chunks = 0